/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */

import React, { Component } from 'react';
import { staticContentsImagePath as BASE_IMAGE_PATH, OPERATOR_ID} from '../../configs/const';
import { DOMAINDISPLAY } from '../../configs/apkFileName';

let oid = OPERATOR_ID.toLowerCase()


export default class HowToPlay extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }
    
    render() {
        return (
            <>
           <section className='sportbook-livecasino'>                
                <div className="subpage-head1">
                    <div className="subpage-head1__image">
                        <img alt="Offers Banner" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/offers-banner.jpg"} />
                    </div> 
                    <div className="subpage-head1__content">
                        <h1 className="subpage-head1__title">How To Play</h1>
                    </div>
                </div>
            </section>
                <div className="container mt-5">
                    <div className="row">
                       <div className='col-12'>
                            {/* <p className='section-head__title text-center text-uppercase termsbox'>Privacy Policy</p> */}
                        </div>
                        <div className='col-12 loginrulesbox'>
                        <p className='loginrulestitle'>You need to create/sign into account, then you can find information about odds and events on
the Sports and Live page. You can place a bet after registration. Complete the registration
process. To log in, enter your username (ID) and password in the relevant fields. You will need a
positive account balance to place a bet. You can make a deposit using available payment
methods ("Deposit" section).
</p>


    <ul className="rulesul">
        <li>Select Sports or Live in the main menu.</li>
        <li>In the left column on the next page choose a sport and an event.</li>
        <li>You will see the odds and the markets in the central section.</li>
        <li>To add a bet, click on the odds and the event will appear in the bet slip.</li>
        <li>f there are several different bets on the bet slip, select the type of bet: Accumulator, System or Chain.</li>
        <li>Enter stake amount.</li>
        <li>Press "Place a bet".</li>
        <li>You will see a pop-up window with the details of your bet.</li>
        <li>Once the bet is accepted, the stake will be deducted from your account immediately.</li>
        <li>You can see your bets in the "Recent bets" section or in My Account – Bet history</li>
        <li>In the case of a win, the funds are transferred to your account automatically after the bet has been settled.</li>
    </ul>
<p className='loginrulestitle font-bold'>ONE-CLICK BET</p>
<p className='loginrulestitle'>One-click bet allows you to bet an amount chosen with a single click on selected odds.<br></br>
To activate "One-click bet", please do the following:
</p>
<ul className="rulesul">
    <li>tick the box "One-click bet";</li>
    <li>enter stake amount;</li>
    <li>press "Apply";</li>
    <li>you will see a pop-up window "The stake is set"</li>
</ul>

<p className='loginrulestitle'>Once One-click bet is activated, the customer can place bets with one click on the
selected odds. Further confirmation is not required. Warning! With "One-click bet", any
click on the odds will lead to the placing of a bet</p>
<p className='loginrulestitle'>To disable "One-click bet", untick the checkbox "One-click bet".</p>

<p className='loginrulestitle font-bold'>Betting rules</p>
<ul className="rulesul">
    <li>You can bet up to 10 events in an accumulator</li>
    <li>If the first event is correct, your stake for the following ones will be multiplied by the odds shown when you accepted it</li>
    <li>A bet within a system doesn’t take place if one of the events is incorrect</li>
    <li>Within a chain, if none of the events are correct, your stake will not be returned</li>
    <li>Additionally, you can place up to 3 accumulators in one game.</li>
    <li>You will find the general and specific conditions of the bet located above the odds.</li>
    <li>To sharpen your betting skills and increase your chances of winning, use accumulator
bets and try to predict the results correctly.</li>
    <li>Accumulator bet is pretty straightforward. You predict that all of the chosen events will
happen. The bet will be settled as correct if this happens. If it is not, your stake remains
unclaimed</li>
</ul>
                    


                                
                                    
                                    </div>
                        </div>
                </div>
                
            </>
        )
    }
}
